import { IOSDetalhada } from '../interfaces/os/IOSDetalhada';

export class OSDetalhada implements IOSDetalhada {
  codigoOS = '';
  retornoOS = '';
  status = '';
  cliente = '';
  email = '';
  telefone = '';
  unidade = '';
  numserie = '';
  marca?: string | undefined;
  modelo?: string | undefined;
  endereco = '';
  responsavel?: string | undefined;
  departamento?: string | undefined;
  categoria?: string | undefined;
  dataAbertura = '';
  prioridade?: string | undefined;
  inicializacao?: string | undefined;
  deadline?: string | undefined;
}
